<app-base-layout [darkMode]="false" [showFooter]="true">
  <form [formGroup]="formGroup" (ngSubmit)="continuar()" class="form-next">
    <h1 class="form-next-title">Verificação de SMS</h1>
    <h2 class="form-next-description">Digite o código de 6 dígitos recebido no número {{ telefone }}</h2>
    <div class="otp-container">
      <input
        *ngFor="let digit of otpDigits; let i = index"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="1"
        class="otp-input"
        [formControl]="getFormControl(i)"
        (input)="onOtpInput($event, i)"
        (keydown)="onOtpKeyDown($event, i)"
        (paste)="onOtpPaste($event)"
        autocomplete="off"
      />
    </div>

    <div class="resend-container">
      <p class="countdown-text">
        <span *ngIf="countdownSeconds > 0">
          Você pode solicitar um novo código em {{ countdownSeconds }} segundos
        </span>
        <span *ngIf="countdownSeconds === 0">
          Você já pode solicitar um novo código
        </span>
      </p>

      <button 
        type="button" 
        class="btn-resend" 
        (click)="reenviar()"
        [disabled]="countdownSeconds > 0 || isLoading">
        Reenviar código
      </button>
    </div>

    <button
      *ngIf="isValid()"
      type="submit"
      [disabled]="isSubmited || isLoading"
      class="btn-avancar">
      <span *ngIf="!isLoading">Validar código</span>
      <span *ngIf="isLoading">Validando...</span>
      <mat-icon *ngIf="!isLoading" aria-hidden="false" aria-label="Validar">
        navigate_next
      </mat-icon>
      <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
    </button>
  </form>
</app-base-layout>
